import {
    setViewedFeatureAnnouncementsInLocalStorage,
} from '../lib/local-storage';

import { useEffect, useState } from 'react';

import {
    Button,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    Typography,
} from '@material-tailwind/react';

interface Props {
    newReleases: any[],
}

const FeatureAnnouncement = ({ newReleases }: Props) => {
    const [openFeatureAnnouncement, setOpenFeatureAnnouncement] = useState(
		newReleases.length > 0
	);

    useEffect(() => {
        console.log(`updated newReleases ${newReleases}`);
        setOpenFeatureAnnouncement(newReleases.length > 0);
    }, [newReleases]);

    const OpenFeatureAnnouncement = () => {
		if (openFeatureAnnouncement) {
			setViewedFeatureAnnouncementsInLocalStorage(
				newReleases.map((n) => n.version)
			);
		}

		setOpenFeatureAnnouncement(!openFeatureAnnouncement);
	};

    return (
        < Dialog
            open={openFeatureAnnouncement}
            handler={OpenFeatureAnnouncement}
        >
            <DialogHeader>Announcement</DialogHeader>
            <DialogBody className="pb-8">
                {newReleases.map((release: any) => {
                    return (
                        <div>
                            <Typography>
                                <strong>
                                    {release.date} (v{release.version})
                                </strong>{' '}
                                : {release.description}
                            </Typography>
                            {release.newFeatures && (
                                <div>
                                    <Typography
                                        variant="h6"
                                        color="blue-gray"
                                    >
                                        New features:
                                    </Typography>
                                    <ul>
                                        {release.newFeatures.map((n) => {
                                            return <li>- {n}</li>;
                                        })}
                                    </ul>
                                </div>
                            )}

                            {release.bugFixes && (
                                <div>
                                    <Typography
                                        variant="h6"
                                        color="blue-gray"
                                    >
                                        Bug fixes:
                                    </Typography>
                                    <ul>
                                        {release.bugFixes.map((n) => {
                                            return <li>- {n}</li>;
                                        })}
                                    </ul>
                                </div>
                            )}

                            {release.perfImprovements && (
                                <div>
                                    <Typography
                                        variant="h6"
                                        color="blue-gray"
                                    >
                                        Performance improvements:
                                    </Typography>
                                    <ul>
                                        {release.perfImprovements.map(
                                            (n) => {
                                                return <li>- {n}</li>;
                                            }
                                        )}
                                    </ul>
                                </div>
                            )}

                            {release.otherChanges && (
                                <div>
                                    <Typography
                                        variant="h6"
                                        color="blue-gray"
                                    >
                                        Other changes:
                                    </Typography>
                                    <ul>
                                        {release.otherChanges.map((n) => {
                                            return <li>- {n}</li>;
                                        })}
                                    </ul>
                                </div>
                            )}
                        </div>
                    );
                })}
                {/* {releases[0].description && (
        <Typography>
          releases[0].description
        </Typography>
      )} */}
            </DialogBody>
            <DialogFooter>
                <Button
                    variant="gradient"
                    color="blue"
                    onClick={OpenFeatureAnnouncement}
                >
                    <span>Close</span>
                </Button>
            </DialogFooter>
        </Dialog >
    );
};

export default FeatureAnnouncement;
